export const authPaths = {
  login: '/login',
  register: '/register',
  forbidden: '/forbidden',
  verifyAuthCode: '/verify-auth-code',
};
